import { useCallback, useEffect, useRef, useState } from 'react';
import { requestReadState } from '../../services/readerActivity';
import { notificationId } from './circleActivityUtils';
export default function useCircleReads() {
  const [state,setState]=useState({ids:new Set(),owner:null,loading:true,error:''});
  const current=useRef(state); current.current=state;
  const version=useRef(0),abort=useRef(null),mounted=useRef(false),saving=useRef(false);
  const refreshReads=useCallback(async()=>{
    const request=++version.current;abort.current?.abort();const controller=new AbortController();abort.current=controller;
    setState(s=>({...s,loading:true,error:''}));
    try {
      const data=await requestReadState(undefined,{signal:controller.signal});
      if(!mounted.current||request!==version.current)return;
      setState(s=>({owner:data.readerSub,ids:new Set([...(s.owner===data.readerSub?s.ids:[]),...data.notificationIds]),loading:false,error:''}));
    } catch {if(mounted.current&&request===version.current)setState({owner:null,ids:new Set(),loading:false,error:'Read status is unavailable. Please retry.'});}
  },[]);
  const cancelReads=useCallback(()=>{++version.current;abort.current?.abort();},[]);
  useEffect(()=>{
    mounted.current=true;refreshReads();
    const refresh=()=>{if(!document.hidden)refreshReads();};
    window.addEventListener('focus',refresh);document.addEventListener('visibilitychange',refresh);
    return()=>{mounted.current=false;cancelReads();window.removeEventListener('focus',refresh);document.removeEventListener('visibilitychange',refresh);};
  },[refreshReads,cancelReads]);
  const markRead=async items=>{
    const owner=current.current.owner,request=version.current;
    if(saving.current||!owner||current.current.loading)return;
    saving.current=true;
    try {
      const ids=[...new Set(items.map(notificationId))];
      for(let offset=0;offset<ids.length;offset+=100){
        if(!mounted.current||request!==version.current)return;
        const data=await requestReadState(ids.slice(offset,offset+100),{owner});
        if(!mounted.current||request!==version.current)return;
        setState(s=>s.owner===owner?{...s,ids:new Set([...s.ids,...data.notificationIds]),error:''}:s);
      }
    }catch{if(mounted.current&&request===version.current)setState({owner:null,ids:new Set(),loading:false,error:'We couldn’t save read status. Retry read status before trying again.'});}
    finally{saving.current=false;}
  };
  return {readIds:state.ids,readsOwner:state.owner,markRead,readError:state.error,readsLoading:state.loading,refreshReads};
}
